import React, { useState, useEffect } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import useConfiguration from 'components/Footer/useConfiguration';
import { SearchIcon, ExportIcon } from 'components/Icons/Glyphs';
import AppleStore from 'components/buttons/stores/AppleStore';
import GooglePlay from 'components/buttons/stores/GooglePlay';
import { NavigationButton } from 'components/buttons/Button';
import { NavLink, useLocation } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import LangSwitcher from 'components/LangSwitcher';
import UserControlls from './UserControlls';
import HumbMenu from './components/HumbMenu';
import Logotype from 'components/Logotype';
import Filter from './Filter';
import Search from './Search';
import Banner from './Banner';
import './style.scss';

const HEADER_MODE_SEARCH = 'HEADER_MODE_SEARCH';
const HEADER_MODE_FILTER = 'HEADER_MODE_FILTER';

const Extra = () => {
    const location = useLocation();
    //TODO: Path logic need to be moved to ZTRouter hooks/component
    return location.pathname === '/' ? <Banner /> : null; 
}

export const AppInstallIcons = props => {
    return <>
        <AppleStore style={{margin: 8}} />
        <GooglePlay style={{margin: 8}} />
    </>
}

const modeFromLocation = location => {
    if (location.pathname === '/filter') {
        return HEADER_MODE_FILTER;
    }
    if (!['/', '/fliter'].includes(location.pathname)) {
        return null;
    }
    return HEADER_MODE_SEARCH;
}


export default () => {
    const location = useLocation();
    const [mode, setMode] = useState(modeFromLocation(location)); 

    useEffect(()=>{
        setMode(modeFromLocation(location));
    }, [location]);

    const onSearchClick = () => setMode(HEADER_MODE_SEARCH);
    const onFilterClick = () => setMode(HEADER_MODE_FILTER);

    const isHome = ['/', '/filter'].includes(location.pathname);

    const { trim } = useConfiguration();

    console.log('*** Header render', mode);

    return (
        <Container>
            {/* <Row style={{marginTop: 8, marginBottom: 8}}><Col className="d-flex justify-content-center align-items-center"><LangSwitcher /></Col></Row> */}
            <Row className='header'>
                <Col xs={6} sm={6} md={4} className='logo d-flex justify-content-start align-items-center'>
                    <HumbMenu />
                    <NavLink to='/'><Logotype style={{marginLeft: 16}} /></NavLink>
                </Col>
                {!trim && <Col xs={12} sm={12} md={4} className='order-2 order-sm-2 order-md-1 d-flex justify-content-center align-items-center'>
                    {/* <AppInstallIcons /> */}
                    <LangSwitcher />
                </Col>}
                {!trim && (
                <Col xs={6} sm={6} md={4} className='order-1 order-sm-1 order-md-2 controls d-flex justify-content-end align-items-center'>
                    {isHome &&
                    <>
                        <NavigationButton icon={SearchIcon} onClick={onSearchClick} selected={mode === HEADER_MODE_SEARCH} />
                        <NavigationButton icon={ExportIcon} onClick={onFilterClick} selected={mode === HEADER_MODE_FILTER} className="mr-2" />
                    </>
                    }
                    <UserControlls style={{marginRight: 8}} />
                </Col>
                )}
            </Row>
            <SwitchTransition>
            <CSSTransition key={mode || 'banner'} in={mode === HEADER_MODE_FILTER} timeout={200} classNames={mode === null ? 'headertr-banner' : 'headertr'} unmountOnExit>
                {{
                    [HEADER_MODE_SEARCH]: <Search />,
                    [HEADER_MODE_FILTER]: <Filter /> 
                }[mode] || <Extra />}
            </CSSTransition> 
            </SwitchTransition>
        </Container>
    );
};